/* five — quick hits lander runtime. Reads config from #qh-config JSON. */
(function () {
  var root = document.getElementById('qh-frame');
  if (!root) return;
  var cfg = {};
  try { cfg = JSON.parse(document.getElementById('qh-config').textContent); } catch (e) {}

  var P = {
    variety: parseFloat(cfg.priceVariety) || 44.99,
    varietyCompare: parseFloat(cfg.compareVariety) || 119.96,
    pouch: parseFloat(cfg.pricePouch) || 17.5,
    pouchCompare: parseFloat(cfg.comparePouch) || 34.99,
    tin: parseFloat(cfg.priceTin) || 14.99
  };
  var LIME = cfg.lime || '#AEE848', INK = '#120802', DIM = '#8C8C8C';
  var DEFS = (cfg.strains || []).map(function (x, i) {
    return { key: 'k' + i, name: x.name, cap: String(i), img: x.img, variant: x.variant };
  });

  var st = {
    qty: {},
    varietyQty: 1, mode: 'variety', added: false,
    open: -1, cartOpen: false, slide: 0, pastFold: false, busy: false
  };

  function money(n) { return '$' + n.toFixed(2); }
  function bump(key, d) {
    st.qty[key] = Math.max(0, Math.min(12, (st.qty[key] || 0) + d));
    st.mode = 'custom'; st.added = false; render();
  }
  function scrollTo(id) {
    var el = document.getElementById(id);
    if (el) window.scrollTo({ top: el.getBoundingClientRect().top + window.pageYOffset - 8, behavior: 'smooth' });
  }

  function whenAftersellReady(cb) {
    var tries = 0;
    (function poll() {
      if (window.aftersell && window.aftersell.cart) return cb(window.aftersell.cart);
      if (++tries > 40) return cb(null);
      setTimeout(poll, 100);
    })();
  }

  // The standalone lander hides every body child, so re-reveal the cart's own DOM branch.
  // AfterSell auto-opens its own cart on add-to-cart, so this only needs to run once per
  // node — re-applying it on a timer fights AfterSell's open animation and made the drawer
  // appear to open multiple times.
  var revealedCartNodes = typeof WeakSet === 'function' ? new WeakSet() : null;
  function unhideCartBranch() {
    var nodes = document.querySelectorAll('.aftersell-cart, [id^="aftersell-cart"], cart-drawer');
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if (revealedCartNodes) {
        if (revealedCartNodes.has(el)) continue;
        revealedCartNodes.add(el);
      }
      while (el && el !== document.body) {
        el.style.setProperty('display', '', 'important');
        if (getComputedStyle(el).display === 'none') el.style.setProperty('display', 'block', 'important');
        el = el.parentElement;
      }
    }
  }

  // AfterSell already opens its own cart automatically whenever /cart/add.js is called,
  // so we only need to reveal it on this standalone page and apply the discount code —
  // not trigger opening it ourselves.
  function openSmartCart() {
    document.dispatchEvent(new CustomEvent('qh:added'));
    whenAftersellReady(function (smart) {
      var code = cfg.discountCode;
      var reveal = function () {
        unhideCartBranch();
        setTimeout(unhideCartBranch, 150);
        setTimeout(unhideCartBranch, 600);
      };
      if (!code) return reveal();
      if (smart && typeof smart.applyDiscount === 'function') {
        try { return Promise.resolve(smart.applyDiscount(code)).then(reveal, reveal); } catch (e) {}
      }
      // Fallback: let Shopify set the discount cookie, then reveal whatever cart exists.
      fetch('/discount/' + encodeURIComponent(code), { credentials: 'same-origin' }).then(reveal, reveal);
    });
  }

  function addToCart() {
    if (st.busy) return;
    var items = [];
    if (st.mode === 'variety' && st.varietyQty > 0 && cfg.variantVariety) {
      items.push({ id: Number(cfg.variantVariety), quantity: st.varietyQty });
    }
    DEFS.forEach(function (d) {
      if (st.qty[d.key] > 0 && d.variant) items.push({ id: Number(d.variant), quantity: st.qty[d.key] });
    });
    if (!items.length) { scrollTo('qh-builder'); return; }
    st.busy = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) { return r.json(); }).then(function () {
      st.busy = false; st.added = true; render();
      var after = cfg.afterAdd || 'checkout';
      if (after === 'checkout') {
        window.location.href = cfg.discountCode ? '/checkout?discount=' + encodeURIComponent(cfg.discountCode) : '/checkout';
      } else if (after === 'cart') {
        window.location.href = cfg.discountCode ? '/cart?discount=' + encodeURIComponent(cfg.discountCode) : '/cart';
      } else {
        openSmartCart();
      }
    }).catch(function () { st.busy = false; });
  }

  function values() {
    var vQty = st.mode === 'variety' ? Math.max(0, st.varietyQty) : 0;
    var pouchCount = DEFS.reduce(function (a, d) { return a + (st.qty[d.key] || 0); }, 0);
    var total = P.variety * vQty + P.pouch * pouchCount;
    var units = vQty * 3 + pouchCount;
    var tinUnlocked = vQty >= 1 || pouchCount >= 3;
    var compare = (P.varietyCompare - P.tin) * vQty + P.pouchCompare * pouchCount + (tinUnlocked ? P.tin : 0);
    var toGo = Math.max(0, 3 - pouchCount);
    var empty = vQty === 0 && pouchCount === 0;
    var varietyMode = st.mode === 'variety';

    var v = {
      isVarietyMode: varietyMode, isCustomMode: !varietyMode,
      varietyTabBg: varietyMode ? '#FFFFFF' : '#F2F2F2',
      varietyTabColor: varietyMode ? INK : DIM,
      varietyTabBorder: varietyMode ? LIME : 'transparent',
      customTabBg: varietyMode ? '#F2F2F2' : '#FFFFFF',
      customTabColor: varietyMode ? DIM : INK,
      customTabBorder: varietyMode ? 'transparent' : LIME,
      varietyQty: vQty,
      tinLine: tinUnlocked
        ? 'forever fresh tin added — free (' + money(P.tin) + ' value)'
        : (pouchCount === 0
            ? 'add 3 pouches or the variety pack for a free ' + money(P.tin) + ' tin'
            : 'add ' + toGo + (toGo === 1 ? ' more pouch' : ' more pouches') + ' for a free ' + money(P.tin) + ' tin'),
      tinProgress: tinUnlocked ? '100%' : Math.round(Math.min(1, pouchCount / 3) * 100) + '%',
      tinTextColor: tinUnlocked ? INK : DIM,
      tinImgOpacity: tinUnlocked ? 1 : 0.42,
      itemsLine: empty ? 'pick at least one pouch'
        : units + (units === 1 ? ' pouch · 10 gummies' : ' pouches · ' + units * 10 + ' gummies') + (tinUnlocked ? ' · + free tin' : ''),
      totalLabel: money(total),
      compareLabel: empty ? '' : money(compare),
      savingsLabel: empty ? '' : 'save ' + money(compare - total),
      ctaVerb: st.added ? 'added to cart ✓' : (empty ? 'choose a pouch' : 'add to cart'),
      heroCtaVerb: st.added ? 'added to cart ✓' : 'add to cart',
      heroCtaSave: 'save ' + money(Math.max(1, vQty) * (P.varietyCompare - P.variety)),
      stickyLabel: empty ? 'build your pack'
        : (vQty > 0 && pouchCount > 0
            ? (vQty === 1 ? 'variety pack' : vQty + '× variety pack') + ' + ' + pouchCount + (pouchCount === 1 ? ' pouch' : ' pouches')
            : (vQty > 0 ? (vQty === 1 ? 'the variety pack' : vQty + '× variety pack')
                        : pouchCount + (pouchCount === 1 ? ' pouch' : ' pouches'))),
      stickySub: empty ? cfg.promo1 || '50% off your first order'
        : (tinUnlocked ? 'save ' + money(compare - total) + ' · free tin included' : 'save ' + money(compare - total)),
      stickyCta: st.added ? 'added ✓' : 'add to cart',
      stickyOn: cfg.showSticky !== false,
      showTin: cfg.showTin !== false,
      cartOpen: st.cartOpen,
      uspOpacity: st.pastFold ? '0' : '1',
      stickyImgCss: 'url("' + ((vQty > 0 || pouchCount === 0)
        ? cfg.imgBundle
        : (DEFS.filter(function (d) { return st.qty[d.key] > 0; })[0] || DEFS[0]).img) + '")'
    };

    DEFS.forEach(function (d) {
      v['qty' + d.cap] = st.qty[d.key] || 0;
      v['strainCta' + d.cap] = st.qty[d.key] > 0 ? 'in your pack · ' + st.qty[d.key] : 'add to pack';
    });
    for (var i = 0; i < 5; i++) {
      v['dotW' + i] = st.slide === i ? '22px' : '8px';
      v['dotBg' + i] = st.slide === i ? LIME : 'transparent';
    }
    for (var f = 0; f < 12; f++) v['open' + f] = st.open === f;

    var lines = [];
    if (vQty > 0) lines.push({
      name: cfg.packName || 'the variety pack',
      meta: '3 pouches · 30 gummies · 450mg',
      qty: vQty, price: money(P.variety * vQty), imgCss: 'url("' + cfg.imgBundle + '")',
      inc: function () { st.varietyQty = Math.min(12, st.varietyQty + 1); st.added = false; render(); },
      dec: function () { st.varietyQty = Math.max(0, st.varietyQty - 1); st.added = false; render(); },
      remove: function () { st.varietyQty = 0; st.added = false; render(); }
    });
    DEFS.forEach(function (d) {
      if (st.qty[d.key] > 0) lines.push({
        name: d.name,
        meta: st.qty[d.key] * 10 + ' gummies · ' + st.qty[d.key] * 150 + 'mg thc',
        qty: st.qty[d.key], price: money(P.pouch * st.qty[d.key]),
        imgCss: 'url("' + d.img + '")',
        inc: function () { bump(d.key, 1); }, dec: function () { bump(d.key, -1); },
        remove: function () { st.qty[d.key] = 0; render(); }
      });
    });
    v.cartLines = lines;
    v.cartEmpty = lines.length === 0;
    v.tinInCart = tinUnlocked && lines.length > 0;
    var c = vQty + pouchCount;
    v.cartCountLabel = c === 1 ? '1 item' : c + ' items';
    v.cartToggleLabel = st.cartOpen ? 'hide cart ▾' : (empty ? 'view cart ▴' : 'view cart · ' + v.cartCountLabel + ' ▴');
    return v;
  }

  var paused = false;

  var A = {
    addToCart: addToCart,
    addVarietyDirect: function () { st.mode = 'variety'; st.varietyQty = Math.max(1, st.varietyQty); addToCart(); },
    addVarietyToCart: function () { st.mode = 'variety'; st.varietyQty = Math.max(1, st.varietyQty); addToCart(); },
    scrollToBuilder: function () { scrollTo('qh-builder'); },
    scrollToPicker: function () { scrollTo('qh-picker'); },
    setVarietyMode: function () { st.mode = 'variety'; st.added = false; render(); },
    setCustomMode: function () { st.mode = 'custom'; st.added = false; render(); },
    incVariety: function () { st.mode = 'variety'; st.varietyQty = Math.min(12, st.varietyQty + 1); st.added = false; render(); },
    decVariety: function () { st.mode = 'variety'; st.varietyQty = Math.max(0, st.varietyQty - 1); st.added = false; render(); },
    toggleCart: function () { st.cartOpen = !st.cartOpen; render(); },
    pauseReviews: function () { paused = true; },
    resumeReviews: function () { paused = false; }
  };
  DEFS.forEach(function (d) {
    A['inc' + d.cap] = function () { bump(d.key, 1); };
    A['dec' + d.cap] = function () { bump(d.key, -1); };
    A['addStrain' + d.cap] = function () { st.mode = 'custom'; if (!st.qty[d.key]) st.qty[d.key] = 1; render(); scrollTo('qh-builder'); };
  });
  for (var n = 0; n < 12; n++) (function (i) {
    A['toggle' + i] = function () { st.open = st.open === i ? -1 : i; render(); };
    A['goSlide' + i] = function () { goSlide(i); };
  })(n);

  function goSlide(i) {
    var rail = document.getElementById('qh-rail');
    if (!rail) return;
    rail.scrollTo({ left: i * rail.clientWidth, behavior: 'smooth' });
    st.slide = i; render();
  }

  function render() {
    var v = values();
    root.querySelectorAll('[data-qh-text]').forEach(function (el) {
      var k = el.getAttribute('data-qh-text');
      if (k in v) el.textContent = v[k] == null ? '' : v[k];
    });
    root.querySelectorAll('[data-qh-if]').forEach(function (el) {
      var k = el.getAttribute('data-qh-if');
      if (k === 'true') return;
      if (k === 'false') { el.style.display = 'none'; return; }
      el.style.display = v[k] ? 'contents' : 'none';
    });
    root.querySelectorAll('[data-qh-sty]').forEach(function (el) {
      el.getAttribute('data-qh-sty').split(';').forEach(function (pair) {
        var bits = pair.split('|');
        if (bits.length !== 2 || bits[1].indexOf('line.') === 0) return;
        if (bits[1] in v) el.style.setProperty(bits[0], v[bits[1]]);
      });
    });
    var slides = document.querySelectorAll('#qh-rail > div').length;
    for (var i = 0; i < 5; i++) {
      var dot = root.querySelector('[data-qh-click="goSlide' + i + '"]');
      if (dot) dot.style.display = i < slides ? 'block' : 'none';
    }
    renderLines(v);
  }

  function renderLines(v) {
    root.querySelectorAll('[data-qh-for="cartLines"]').forEach(function (host) {
      var tpl = host.querySelector('template');
      if (!tpl) return;
      Array.prototype.slice.call(host.children).forEach(function (c) { if (c !== tpl) host.removeChild(c); });
      v.cartLines.forEach(function (line) {
        var node = tpl.content.cloneNode(true);
        node.querySelectorAll('[data-qh-text]').forEach(function (el) {
          var k = el.getAttribute('data-qh-text');
          if (k.indexOf('line.') === 0) el.textContent = line[k.slice(5)];
        });
        node.querySelectorAll('[data-qh-sty]').forEach(function (el) {
          el.getAttribute('data-qh-sty').split(';').forEach(function (pair) {
            var b = pair.split('|');
            if (b.length === 2 && b[1].indexOf('line.') === 0) el.style.setProperty(b[0], line[b[1].slice(5)]);
          });
        });
        node.querySelectorAll('[data-qh-click]').forEach(function (el) {
          var k = el.getAttribute('data-qh-click');
          if (k.indexOf('line.') === 0) el.addEventListener('click', line[k.slice(5)]);
        });
        host.appendChild(node);
      });
    });
  }

  root.addEventListener('click', function (e) {
    var el = e.target.closest('[data-qh-click]');
    if (!el || !root.contains(el)) return;
    var k = el.getAttribute('data-qh-click');
    if (k.indexOf('line.') === 0) return;
    if (A[k]) { e.preventDefault(); A[k](); }
  });

  var rail = document.getElementById('qh-rail');
  if (rail) rail.addEventListener('scroll', function () {
    if (!rail.clientWidth) return;
    var i = Math.round(rail.scrollLeft / rail.clientWidth);
    if (i !== st.slide) { st.slide = i; render(); }
  }, { passive: true });

  var rev = document.getElementById('qh-reviews-rail');
  if (rev) {
    rev.addEventListener('mouseenter', function () { paused = true; });
    rev.addEventListener('mouseleave', function () { paused = false; });
    rev.addEventListener('touchstart', function () { paused = true; }, { passive: true });
    setInterval(function () {
      if (paused || !rev.scrollWidth) return;
      var step = rev.firstElementChild ? rev.firstElementChild.getBoundingClientRect().width + 16 : 340;
      if (rev.scrollLeft + rev.clientWidth >= rev.scrollWidth - 8) rev.scrollTo({ left: 0, behavior: 'smooth' });
      else rev.scrollBy({ left: step, behavior: 'smooth' });
    }, 4200);
  }

  var picker = document.getElementById('qh-picker');
  window.addEventListener('scroll', function () {
    var past = picker ? picker.getBoundingClientRect().bottom < 0 : window.pageYOffset > 600;
    if (past !== st.pastFold) { st.pastFold = past; render(); }
  }, { passive: true });

  render();
})();
